import React from "react";
const Landing = ({ data, date }) => {
  return (
    <div className="map mb-secondary lg:mb-primary map">
      <p className="mb-2">{date}</p>
      <div
        className="text-lg text-white custom-content"
        dangerouslySetInnerHTML={{ __html: data }}
      />
    </div>
  );
};

export default Landing;
